const gauth2Config = {
    clientId: '93606334693-f28525f8rp3ikocldn7lk1f42akjvn96.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account',
    ux_mode: 'popup',
    // redirect_uri: `${mainPath}/signin`,
    // redirect_uri: `${mainPath}/connect/google/callback`,
};

declare module 'vue/types/vue' {
    interface Vue {
      $gAuth: any;
    }
}

export default gauth2Config;
